export default {
	a_great_community_awaits_you: 'Una gran comunidad te espera',
	about_the: 'Sobre la',
	access_platform: 'Acceder a la plataforma',
	access: 'Entrar',
	active_users: '{users} usuarios activos',
	an_email_has_been_sent_to: 'Se ha enviado un correo electrónico a',
	are_you_a_continental_partner: '¿Eres un socio Continental?',
	certificates_obtained_in_training: 'Certificados obtenidos en formación',
	change_country: "Cambiar pais",
	check_your_email_for_password_recovery_instructions:
		'Revise su correo electrónico para obtener instrucciones de recuperación de contraseña.',
	click_on_the_button_below_to_perform_the_first_access:
		'Haga clic en el botón de abajo para realizar el primer acceso',
	code: 'Código',
	to_the_document_informed:
		'al documento informado.',
	ddd_plus_number_ex: 'DDD más número. Ej. 1199999999',
	discover_new_techniques_in_current_and_diversified_courses:
		'Descubrir nuevas técnicas en cursos actuales y diversificados.',
	do_apply: 'Se aplican',
	document_cpf: 'CPF',
	document: 'Documento',
	email_already_in_use_click: 'Correo electrónico ya en uso. Clic',
	enter_full_company_name: 'Introduzca el nombre completo de la empresa',
	email_invalid_error: 'Dirección de correo electrónico no válida' ,
	enter_a_new_password: 'Introduzca una nueva contraseña.',
	enter_the_code_received_through_the_selected_recovery_method_to_create_a_new_password:
		'Introduzca el código recibido a través del método de recuperación seleccionado para crear una nueva contraseña',
	enter_your_document_to_check_the_options_available_with_your_phone_number_for_password_recovery:
		'Ingrese su documento para verificar las opciones disponibles con su número de teléfono para la recuperación de contraseña.',
	enter_your_new_password: 'Introduzca su nueva contraseña',
	enter_your_phone_number_below_and_press_send_to_receive_a_confirmation_code:
		'Ingrese su número de teléfono a continuación y presione enviar para recibir un código de confirmación.',
	error_logging_in_check_the_user_and_password_entered:
		'Error al iniciar sesión. Verifique el usuario y la contraseña ingresados.',
	error_setting_new_password: 'Error al establecer una nueva contraseña.',
	forgot_password: '¿Olvidaste tu contraseña?',
	select_an_available_option_to_receive_the_verification_code:
		'Seleccione una opción disponible para recibir el código de verificación',
	in: 'en',
	log_in_to_receive_an_email_with_instructions_and_a_link_to_create_a_new_password:
		'Ingresá tu usuario para recibir un correo electrónico con instrucciones para crear una nueva contraseña.',
	login_to_access_your_account: 'Haz login para acceder a tu cuenta',
	more_than_courses: 'Más de {courses} cursos',
	no_company_agency_found: 'No se encontró empresa / agencia',
	or: 'O',
	password_changed_successfully: 'Contraseña alterada con éxito.',
	password_setting_link_expired:
		"Vínculo de configuración de contraseña vencido. Haga clic aquí en 'Olvidé mi contraseña' para solicitar un nuevo enlace.",
	phone_number: 'Número de teléfono',
	Please_wait_we_are_validating_your_access: 'Espere por favor. Estamos validando tu acceso',
	recover_password_with_sms: 'Recuperar contraseña con SMS o Whatsapp',
	recover_password_with_username: 'Recuperar contraseña con nombre de usuario',
	recover_password: 'Recuperar contraseña',
	recover_your_password: 'Recupera tu contraseña',
	request_code: 'Solicitar código',
	request_new_code: 'Solicitar nuevo código',
	sap_code: 'Código SAP o número de registro la empresa',
	seconds: 'segundos',
	select_your_country: 'Selecciona tu pais',
	select: 'Seleccionar',
	send_code: 'Enviar código',
	set_new_password: 'Establecer nueva contraseña',
	sign_in: 'Entrar',
	sign_up: 'Registrarse',
	temporary_password: 'Contraseña temporal',
	terms_of_service: 'Términos de servicio',
	the_code_sent_is_not_valid: 'El código enviado no es válido',
	the_informed_user_could_not_be_found_please_check_the_data_provided:
		'No se pudo encontrar al usuario informado. Verifique los datos proporcionados.',
	the_number_entered_does_not_correspond_to_the_registered_number:
		'El número introducido no corresponde al número registrado',
	the_password_reset_link_is_invalid:
		'El link de restablecimiento de contraseña no es válido. Por favor, solicite uno nuevo.',
	there_is_no_registered_phone_for_this_user: 'No hay un teléfono registrado para este usuario',
	this_site_is_protected_by_googles_recaptcha:
		'Este website está protegido por recaptcha de Google',
	to_access_this_website_you_need_to_login_first_at_the_intel_retail_edge_program_and_click_on_the_intel_rewards_you_link_on_the_menu:
		'Para acceder a este sitio web, primero debes iniciar sesión en el programa Intel® Retail Edge y hacer clic en el enlace Intel Te Premia del menú.',
	to_recover_your_password: 'Para recuperar su contraseña',
	under_maintenance: 'En manutención',
	use_document_and_default_password_to_login:
		'Ingrese su documento de inicio de sesión para recibir un correo electrónico con instrucciones y un enlace para crear una nueva contraseña.',
	use_only_numbers_ex: 'Utilice solo números. Ej. 123456789',
	use_your_email_or_document_to_recover_your_password:
		'Utilizá tu correo electrónico o documento para recuperar tu contraseña.',
	user_doesnt_have_access: 'El usuario no tiene acceso',
	user_registered_success: 'Usuario registrado exitosamente.',
	we_are_under_renovation_and_soon_we_will_bring_a_new_platform_full_of_news_for_you:
		'¡Estamos en renovación y pronto tendremos una nueva plataforma llena de novedades para ti!',
	we_found_the_phone_number: 'Encontramos el número de teléfono',
	welcome_to: 'Bienvenido(a) a',
	to_recover_your_password_using_email_or_sms:
		'para recuperar su contraseña utilizando su correo electrónico o número de teléfono registrado. ',
	you_can_recover_your_password_using_your_email_or_document_or_sms:
		"Haga clic en 'Olvidé mi contraseña' y elija recuperarla usando su correo electrónico (use su documento o correo electrónico) o SMS (use su número de teléfono) y obtenga un enlace para crear una nueva contraseña. ",
	you_can_recover_your_password_using_your_email_or_sms:
		"Haga clic en 'Olvidé mi contraseña' y elija recuperarla usando su correo electrónico o SMS y obtenga un enlace para crear una nueva contraseña. ",
	password_recovery: 'Recuperación de contraseña',
	login_azure: 'Acceso Directo',
	user_not_found_contact_to: 'Usuario no encontrado. Contacte a',
	to_request_to_access_on_the_platform: 'para solicitar acceso a la plataforma.',
	warning_to_inative_accounts: "* Atención: durante los periodos de vacaciones o bajas, el acceso a la plataforma queda temporalmente suspendido."
}
